<div *ngIf="useMobileDesign">
  <!-- <code>** Mobile Design activated**</code> -->
  <taku-return-invoice-doc-mobile #invoiceDocComponent></taku-return-invoice-doc-mobile>
</div>

<div *ngIf="useTabletDesign">
  <!-- <code>** Tablet Design activated**</code> -->
  <taku-return-invoice-doc-mobile #invoiceDocComponent></taku-return-invoice-doc-mobile>
</div>

<div *ngIf="useDesktopDesign">
  <!-- <code>** Desktop Design activated**</code> -->
  <taku-return-invoice-doc-desktop #invoiceDocComponent></taku-return-invoice-doc-desktop>
</div>
